import { gql } from '@apollo/client';
import { client as apolloClient } from '@xbcb/apollo-client';

const GENERATE_JWT = gql`
  query GenerateJWT($login: String) {
    generateJWT(login: $login)
  }
`;

/**
 * Generates a Connect Pro JWT token for the currently authenticated operator.
 * The server derives the operator's login from the authenticated session context,
 * falling back to the provided login if the context header is unavailable.
 *
 * @param {string} [login] - Optional operator login as fallback.
 * @return {Promise<string>} The JWT token or empty string on failure.
 */
export const getConnectProToken = async (login?: string): Promise<string> => {
  try {
    const { data } = await apolloClient.query({
      query: GENERATE_JWT,
      variables: { login },
    });
    return data?.generateJWT || '';
  } catch (error) {
    console.error('Failed to generate JWT token:', error);
    return '';
  }
};
